import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { FiHeart, FiMapPin } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css"; 
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Faqs from "../../component/Faqs";
import PageCount from "../../component/utils/PageCount";

function NewFaqs() {
   
  return (
    <section className=" ">
       
       <PageCount pageName = {"Faq"}/>
       <Faqs/>

    </section>
  );
}

export default NewFaqs;
